import { fetchApi } from '@/services/api-client';

export const SCHOOL_CLASSES_PATH = '/admin/classes';

export type SchoolClass = {
  id: string;
  schoolYearId: string;
  gradeLevel: number;
  name: string;
  /** Staff user id. */
  homeroomTeacherId: string | null;
  homeroomTeacherName: string | null;
  homeroomRoomId: string | null;
  homeroomRoomName: string | null;
  active: boolean;
  perPeriodAttendance: boolean;
  lunchGroup: 'first' | 'second' | null;
  temperatureTracking: boolean;
  /** Staff user ids, sorted by id — same order as `assistantTeacherNames`. */
  assistantTeacherIds: string[];
  assistantTeacherNames: string[];
  createdAt: string;
  updatedAt: string;
};

export const schoolClassesApi = {
  list: (schoolYearId: string) =>
    fetchApi<SchoolClass[]>(`${SCHOOL_CLASSES_PATH}?schoolYearId=${encodeURIComponent(schoolYearId)}`),

  create: (data: {
    schoolYearId: string;
    gradeLevel: number;
    name: string;
    homeroomTeacherId?: string | null;
    homeroomRoomId?: string | null;
    active?: boolean;
    perPeriodAttendance?: boolean;
    lunchGroup?: 'first' | 'second' | null;
    temperatureTracking?: boolean;
    /** Present replaces the assistant set; absent leaves it unchanged. */
    assistantTeacherIds?: string[];
  }) => fetchApi<SchoolClass>(SCHOOL_CLASSES_PATH, { method: 'POST', body: JSON.stringify(data) }),

  update: (
    id: string,
    data: {
      gradeLevel?: number;
      name?: string;
      homeroomTeacherId?: string | null;
      homeroomRoomId?: string | null;
      active?: boolean;
      perPeriodAttendance?: boolean;
      lunchGroup?: 'first' | 'second' | null;
      temperatureTracking?: boolean;
      /** Present replaces the assistant set; absent leaves it unchanged. */
      assistantTeacherIds?: string[];
    }
  ) =>
    fetchApi<SchoolClass>(`${SCHOOL_CLASSES_PATH}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),

  delete: (id: string) => fetchApi<{ success: boolean }>(`${SCHOOL_CLASSES_PATH}/${id}`, { method: 'DELETE' }),

  ensureGrades: (schoolYearId: string) =>
    fetchApi<SchoolClass[]>(`${SCHOOL_CLASSES_PATH}/ensure-grades`, {
      method: 'POST',
      body: JSON.stringify({ schoolYearId }),
    }),
};
